var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDimensions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 390 386.7",
    style: {
      enableBackground: "new 0 0 390 386.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M367.4,134.4l22.6-22.6L278.2,0l-22.6,22.6l28.6,28.6H65.8l28.6-28.6L71.9,0L4.7,67.2l67.2,67.2l22.6-22.6L65.8,83.2h218.4 l-28.6,28.6l22.6,22.6l28.6-28.6v218.4l-28.6-28.6l-22.6,22.6l67.2,67.2l67.2-67.2l-22.6-22.6l-28.6,28.6V105.8L367.4,134.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M223.6,286.2l22.6-22.6L123.1,140.5L0,263.6l22.6,22.6l20.7-20.7v89.2H3.3v31.9h239.6v-31.9H203v-89.2L223.6,286.2z  M171,354.7h-31.9v-47.9h-31.9v47.9H75.2V233.6l47.9-47.9l47.9,47.9V354.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensions);
export default __webpack_public_path__ + "static/media/dimensions.d248a369c56b0b29201829eb02871df8.svg";
export { ForwardRef as ReactComponent };